import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/HomePage/HomePage";
import Page1 from "../pages/Page1";
import Page2 from "../pages/Page2";
import CompletedPage from "../pages/CompletedPage/CompletedPage";
import TokenFailPage from "../pages/TokenFailPage/TokenFailPage";
import FinanceDetailsPage from "../pages/FinanceDetailsPage/FinanceDetailsPage";
import { AzureAD } from "react-aad-msal";
import { authProvider } from "../../authProvider";

const Main = () => {
  return (
    <div>
      <main>
        <AzureAD provider={authProvider} forceLogin={true}>
          <Routes>
            <Route path="/page2" element={<Page2 />} />
            <Route path="/page1" element={<Page1 />} />
            <Route path="/tokenfail" element={<TokenFailPage />} />
            <Route path="/complete" element={<CompletedPage />} />
            <Route path="/requests" element={<Home />} />
            <Route path="/requests/:id" element={<FinanceDetailsPage />} />
            <Route exact path="/" element={<Navigate to="/requests" />} />
          </Routes>
        </AzureAD>
      </main>
    </div>
  );
};

export default Main;
